/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { LoginHeader } from "./LoginHeader";
import "./style.css";
import { UserLoginModal } from "./user-login-modal/UserLoginModal";
import { useSetAuthCode } from "../core/_requests";
import { finishLinkLogin } from "../core/AuthHelpers";
import { markActivity } from "../core/idle";
import { useAuth } from "../core/Auth";
import { UserLockModal } from "./user-lock-modal/UserLockModal";

interface CustomError extends Error {
  response?: {
    data: any;
    status: number;
    headers: any;
  };
}

export function Login() {
  const [errorUserCode, setErrorUserCode] = useState<any | null>(null);
  const exchanged = useRef(false);

  const [searchParams] = useSearchParams();

  const { isAuth, isLockUser, userCode, setUserCode, setShouldRefetchUser } =
    useAuth();

  const {
    mutate: setAuthCode,
    isLoading: isSetAuthCodeLoading,
    data: authCodeData,
    error: setAuthCodeError,
  } = useSetAuthCode();

  // Код входа из ссылки Telegram-бота.
  useEffect(() => {
    setUserCode(searchParams.get("code"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  // Обмен кода на сессию (сервер выставит cookie). Один раз на код.
  useEffect(() => {
    if (userCode && !exchanged.current) {
      exchanged.current = true;
      setAuthCode(userCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userCode]);

  // Успешный вход = сразу авторизован (PIN больше нет) → перезапрашиваем профиль,
  // AuthInit подхватит его и переключит роутинг на приватные страницы.
  useEffect(() => {
    if (authCodeData) {
      // Вход — это действие человека, и отсчёт простоя начинается с него.
      // Иначе счётчик, оставшийся в localStorage с прошлой вкладки, запер бы
      // только что вошедшего: бэк окно открыл, а фронт его тут же закрыл бы.
      markActivity();
      setShouldRefetchUser(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authCodeData]);

  // Обмен кода завершился — удачно или нет, неважно. С этого момента 403
  // reverify_required относится уже к текущей сессии, то есть к простою, и
  // окно с кодом снова уместно.
  useEffect(() => {
    if (authCodeData || setAuthCodeError) {
      finishLinkLogin();
    }
  }, [authCodeData, setAuthCodeError]);

  useEffect(() => {
    if (setAuthCodeError instanceof Error) {
      const customError = setAuthCodeError as CustomError;
      setErrorUserCode({ error: customError });
    }
  }, [setAuthCodeError]);

  return (
    <div>
      <LoginHeader />

      {!isAuth && !isLockUser && (
        <UserLoginModal
          userCode={userCode}
          error={errorUserCode}
          isloading={isSetAuthCodeLoading}
        />
      )}

      {isLockUser && <UserLockModal />}
    </div>
  );
}
